/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _module = __webpack_require__(1);
	
	(function () {
	  (0, _module.anchorLink)();
	})();
	
	(function () {
	  (0, _module.lowSlider)();
	})();
	
	(function () {
	  (0, _module.headerResize)();
	})();
	
	(function () {
	  (0, _module.studioHover)();
	})();
	
	(function () {
	  (0, _module.toggleMenu)();
	})();

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toggleMenu = exports.studioHover = exports.headerResize = exports.lowSlider = exports.mainSlider = exports.anchorLink = void 0;
	var breakPoint = 767;
	var resizeFlag = false;
	var windowWidth = window.innerWidth;
	var windowHeight = window.innerHeight;
	var windowWidthJ = $(window).width(); // ------------------------------------------------------------------------
	// anchorLink
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	var anchorLink = function anchorLink() {
	  $("a[href^=#]").on("click", function () {
	    var linkSpeed = 800;
	    var linkHref = $(this).attr("href");
	    var linkTarget = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
	    var linkAdjust = 0;
	    var linkPosition = linkTarget.offset().top;
	    $("html, body").animate({
	      scrollTop: linkPosition - linkAdjust
	    }, linkSpeed, "swing");
	    return false;
	  });
	}; // ------------------------------------------------------------------------
	// mainSlider
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.anchorLink = anchorLink;
	
	var mainSlider = function mainSlider() {
	  $('.slider').slick({
	    // autoplay: true,
	    infinite: true,
	    speed: 1000,
	    slidesToShow: 1,
	    centerMode: true,
	    variableWidth: true,
	    focusOnSelect: true,
	    responsive: [{
	      breakpoint: 768,
	      settings: {
	        slidesToShow: 2
	      }
	    }]
	  });
	}; // ------------------------------------------------------------------------
	// lowSlider
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.mainSlider = mainSlider;
	
	var lowSlider = function lowSlider() {
	  $('.slider').slick({
	    // autoplay: true,
	    infinite: true,
	    speed: 1000,
	    slidesToShow: 2,
	    centerMode: true,
	    variableWidth: true,
	    focusOnSelect: true,
	    responsive: [{
	      breakpoint: 768,
	      settings: {
	        slidesToShow: 2
	      }
	    }]
	  });
	}; // ------------------------------------------------------------------------
	// headerResize
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.lowSlider = lowSlider;
	
	var headerResize = function headerResize() {
	  $(window).on("scroll load", function () {
	    var scrollHeight = $(this).scrollTop();
	
	    if (scrollHeight > 200) {
	      $(".st-Header").addClass("scrolled");
	      $(".st-Header_Inner").addClass("scrolled");
	    } else {
	      $(".st-Header").removeClass("scrolled");
	      $(".st-Header_Inner").removeClass("scrolled");
	    }
	  });
	}; //言語切替メニュー
	
	
	exports.headerResize = headerResize;
	
	var studioHover = function studioHover() {
	  var count = 0;
	  var delay = 500;
	  $('.btn-studio,.st-Header_Studio').mouseenter(function () {
	    count++;
	    $(".st-Header_Studio").addClass('in');
	  }).mouseleave(function () {
	    count--;
	    setTimeout(function () {
	      if (!count) {
	        $(".st-Header_Studio").removeClass('in');
	        $(".st-Header_Studio").addClass('out');
	        setTimeout(function () {
	          $(".st-Header_Studio").removeClass('out');
	        }, 500);
	      }
	    }, delay);
	  });
	  $(window).scroll(function () {
	    $(".st-Header_Studio").removeClass('in');
	    $(".st-Header_Studio").removeClass('out');
	  });
	}; // ------------------------------------------------------------------------
	// toggleMenu
	// ----- BOTH
	// ------------------------------------------------------------------------
	
	
	exports.studioHover = studioHover;
	
	var toggleMenu = function toggleMenu() {
	  $('.st-Header_Hamburger > button').on('click', function () {
	    $(this).toggleClass("close");
	    $(".st-Header_Hamburger").toggleClass("open");
	    $(".st-Header_Slide").toggleClass("open");
	  });
	};
	
	exports.toggleMenu = toggleMenu;

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// studio/app.bundle.js